export type OutcomeSourceType = 'ai' | 'human';
export type OutcomeStatus = 'verified' | 'unverified';
export type OutcomeAtiBasis = 'monthly' | 'annual' | 'one_time';

export type OutcomeFilter =
  | 'all'
  | 'verified'
  | 'unverified'
  | 'ai'
  | 'human'
  | 'has_ati'
  | 'no_ati';

export interface Outcome {
  id: string;
  clientId: string;
  description: string;
  tags: string[];
  sourceType: OutcomeSourceType;
  status: OutcomeStatus;
  dateAchieved: string;
  atiValue: number | null;
  atiBasis: OutcomeAtiBasis | null;
  linkedActionId: string | null;
  timeToOutcomeDays: number | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface OutcomesState {
  outcomes: Outcome[];
}
